// @ts-nocheck
import { Box, Typography } from '@mui/material';

import { FORTA_ERROR, FORTA_SUCCESS, FORTA_YELLOW, FORTA_BLUE } from '../../../../utils/colors';
import { InvoiceStatus } from '../../../../constants';

import type { TFunction } from 'i18next';

const backgroundColor = (status: string) => {
  switch (status) {
    case InvoiceStatus.NOT_PAID:
      return FORTA_ERROR;
    case InvoiceStatus.PAID:
      return FORTA_SUCCESS;
    case InvoiceStatus.PARTIALLY_PAID:
      return FORTA_YELLOW;
    case InvoiceStatus.IN_PROGRESS:
      return FORTA_BLUE.bright;
    default:
      return;
  }
};

export const InvoiceStatusRenderer = (status: string, t: TFunction<'invoice'>) => {
  let translationKey: string;

  switch (status) {
    case InvoiceStatus.PAID:
      translationKey = 'invoiceStatus.paid';
      break;
    case InvoiceStatus.NOT_PAID:
      translationKey = 'invoiceStatus.not_paid';
      break;
    case InvoiceStatus.PARTIALLY_PAID:
      translationKey = 'invoiceStatus.partial_payment';
      break;
    case InvoiceStatus.IN_PROGRESS:
      translationKey = 'invoiceStatus.in_progress';
      break;
    default:
      translationKey = `invoiceStatus.${status.split(' ').join('_').toLowerCase()}`;
  }

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
      <Box
        data-testid="status-box"
        sx={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: backgroundColor(status),
          borderRadius: '50%',
          minWidth: 12,
          minHeight: 12,
          width: 12,
          height: 12,
        }}
      ></Box>
      <Typography
        sx={{
          flexShrink: 0,
        }}
      >
        {t(translationKey)}
      </Typography>
    </Box>
  );
};
